export const WEBSOCKET_ERRORS = [
	'closeevent: ping timeout',
	'event: error',
	'event: close',
	'event: disconnect',
	'connection closed',
	'transport error',
	'websocket is closed before the connection is established',
	'closeevent: 1000',
	'closeevent: 1001',
	'closeevent: 1006',
	'closeevent: abnormal closure',
] as const;

export const isWebSocketError = (error: Error): boolean =>
	WEBSOCKET_ERRORS.some((wsError) => error?.message?.toLowerCase()?.includes?.(wsError) ?? false);
